import { render, staticRenderFns } from "./ItemVariantSelector.vue?vue&type=template&id=18f910da&scoped=true"
import script from "./ItemVariantSelector.vue?vue&type=script&lang=js"
export * from "./ItemVariantSelector.vue?vue&type=script&lang=js"
import style0 from "./ItemVariantSelector.vue?vue&type=style&index=0&id=18f910da&prod&lang=scss&scoped=true"
import style1 from "./ItemVariantSelector.vue?vue&type=style&index=1&id=18f910da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f910da",
  null
  
)

export default component.exports